<template>
  <div
    v-if="getRequest && getRequest.length > 0"
    class="join-request-tile"
  >
    <div class="title-container">
      <span class="title"> {{ $t('community.cancelOwnerRequest.pendingApprovalRequests') }} </span>
    </div>
    <div class="description-container">
      <span class="description">{{ $t('community.cancelOwnerRequest.cancelNominationInfo') }}</span>
    </div>
    <div class="valid-join-container">
      <div class="joinRequest">
        <div class="user">
          <user-photo
            class="user-photo"
            :user="getRequest[0].user"
          />
          <div class="name">
            <span>{{ getRequest[0].user.firstName }} {{ getRequest[0].user.lastName }}</span>
          </div>
        </div>
        <img
          @click="cancelRequestMode"
          src="@/assets/Decline.svg"
        />
      </div>
      <modal-confirm
        @confirm="cancel()"
        @close="closeModal()"
        :cancel="$t('community.cancelOwnerRequest.close')"
        :confirm="$t('community.cancelOwnerRequest.cancel')"
        :title="$t('community.cancelOwnerRequest.cancelNomination')"
        :message="$t('community.cancelOwnerRequest.cancelNominationConfirmation')"
        :show-modal="showModal"
      />
    </div>
  </div>
</template>

<script>
import UserPhoto from '@/components/shared/UserPhoto'
import ModalConfirm from '@/components/shared/ModalConfirm'
import { mapState } from 'vuex'

export default {
  name: 'CancelOwnerRequest',
  components: { UserPhoto, ModalConfirm },
  props: {
    communityDetail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    closeModal () {
      this.showModal = false
    },
    cancelRequestMode () {
      this.showModal = true
    },
    cancel () {
      this.$store.dispatch('cancelOwnerRequest', this.getRequest[0])
      this.showModal = false
    }
  },
  computed: {
    ...mapState({
      ownerRequestForOwner: state => state.ownerRequest.ownerRequestForOwner
    }),
    getRequest () {
      return this.ownerRequestForOwner.filter(request => request.idCommunity === this.communityDetail.idCommunity)
    }
  }
}

</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
}
.join-request-tile {
    margin-top: 1rem;
    width: 100%;
    height: fit-content;
    background-color: #FFFFFF;
    box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.2);

    .title-container {
        padding: 10px 0;

        .title {
            font-size: 15px;
            font-weight: 600;
        }
    }

    .description-container {
        padding: 0 10px;
        text-align: left;

        .description {
            font-size: 13px;
        }
    }

    .valid-join-container {
        padding: 15px 0 10px 0;

        .joinRequest {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 17px 5px 7px;

          .user {
            display: flex;
            align-items: center;

            .user-photo {
              height: 3rem;
              border-radius: 100%;
            }

            .name {
              width:8rem;
              display: flex;
              font-size: 14px;
              text-align: left;
              padding-left: 14px;
            }

          }

          img {
            cursor: pointer;
            color: $primary-color;

            &:hover {
              text-decoration: underline;
            }

          }

          .cancel {
            color: $primary-color;
            cursor: pointer;
            font-size: 13px;
          }

        }

        .text {
          text-align: left;
        }
    }
  }

</style>
